import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    "& .MuiPaper-root": {
      overflow: "auto",
    },
    "& .MuiStepLabel-label": {
      color: "#525252",
    },
    "& .MuiStepLabel-active": {
      color: "#000",
    },
    "& .MuiStepLabel-complete": {
      color: "#000",
    }
  }
}));

function getSteps() {
  return ['Select Workflow', 'Select File', 'Confirm Workflow', 'Start Workflow'];
}

const StepperWorkflow = ({ activeStepIndex }) => {
  const classes = useStyles();
  const steps = getSteps();

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStepIndex} alternativeLabel style={{ padding: 24 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper> 
    </div>
  );
};

export default StepperWorkflow;
